import { alpha, Box, FormControl, InputAdornment, InputLabel, styled, TextField } from '@mui/material'
import { KeyboardEvent, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

const FormControlWrapper = styled(FormControl)(({ theme }) => ({
  marginTop: theme.spacing(0),
  marginBottom: theme.spacing(0)
}))

const StartAdornment = styled(InputAdornment, {
  shouldForwardProp: (prop) => prop !== 'disabled'
})<{ disabled?: boolean }>(({ theme, disabled }) => ({
  ...(disabled && {
    color: alpha(theme.palette.text.disabled, 0.15)
  })
}))

function InputNumber({
  number,
  showLabel,
  adornment,
  disabled,
  onChange
}: {
  number?: number
  showLabel?: boolean
  adornment?: string
  disabled?: boolean
  onChange: (value?: number) => void
}) {
  const intl = useIntl()
  const [value, setValue] = useState(number)

  return (
    <Box mt={0}>
      <FormControlWrapper size="small" margin="normal">
        {showLabel && (
          <InputLabel id={`analysis-number-input-label`} variant="outlined">
            <FormattedMessage id="analysis.columnValue.numberFilter.input.label" />
          </InputLabel>
        )}
        <TextField
          disabled={disabled}
          size="small"
          variant="outlined"
          placeholder={
            !disabled ? intl.formatMessage({ id: 'analysis.columnValue.numberFilter.input.placeholder' }) : ''
          }
          defaultValue={number}
          value={number || value}
          type="number"
          name={`analysis-number-input-label`}
          InputProps={{
            'aria-label': 'input-number',
            startAdornment: (
              <StartAdornment disabled={disabled} position="start">
                <>{adornment}</>
              </StartAdornment>
            )
          }}
          onKeyPress={(event: KeyboardEvent<HTMLInputElement>) => {
            const isE = event.key === 'e'
            if (isE) {
              event.preventDefault()
              return
            }
          }}
          onChange={(event) => {
            const target = event.target as HTMLInputElement
            if (target.value === '') {
              onChange(undefined)
              setValue(undefined)
            } else {
              setValue(Number(target.value))
              onChange(Number(target.value))
            }
          }}
          fullWidth={false}
        />
      </FormControlWrapper>
    </Box>
  )
}

export default InputNumber
